<template>
  <div class="flex gap-4 items-center">
    <ImgView
      :img-classes="'w-24 h-20 object-contain'"
      :src="productImage"
      :alt="productName"
    />
    <div class="text-sm">
      {{ productName }}
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ExtraGuaranteeSidebarProduct',

  props: {
    productName: {
      type: String,
      required: true,
    },
    productImage: {
      type: String,
      required: true,
    },
  },
});

</script>
